<template>
<div>
    <Breadcrumbs main="CRM" title="Targets" />
    <!-- Container-fluid starts-->
     <!-- {{ targets }} -->

    
    <div class="container-fluid">
        <div style="padding: 0px 12px; margin-bottom: 16px; display: flex; flex-wrap: wrap; justify-content: space-between">
            <b-button variant="secondary" v-b-modal.target-create-modal>
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="plus" size="18px"></feather>
                    <h7>Quick Add</h7>
                </div>
            </b-button>
            <b-button variant="primary" @click="goBack">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="arrow-left" size="18px"></feather>
                    <h7>Back</h7>
                </div>
            </b-button>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">

                                <div class="card small-widget">
                                    <div class="card-body primary"><span class="f-light">Annual Target</span>
                                        <div class="d-flex gap-1 align-items-end">
                                            <h4>{{ formatM(stats?.annual_target) }}</h4>
                                        </div>
                                        <div class="bg-gradient">
                                            <svg viewBox="0 0 16 16" width="24px" height="24px" fill="#7366ff" xmlns="http://www.w3.org/2000/svg">
                                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                                <g id="SVGRepo_iconCarrier">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8Z" fill="#7366ff"></path>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8Z" fill="#7366ff"></path>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">

                                <div class="card small-widget">
                                    <div class="card-body warning"><span class="f-light">Achieved YTD</span>
                                        <div class="d-flex gap-1 align-items-end">
                                            <h4>{{ formatM(stats?.achieved_ytd) }}</h4>
                                        </div>
                                        <div class="bg-gradient">
                                            <svg viewBox="0 0 24 24" width="24px" height="24px" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                                <g id="SVGRepo_iconCarrier">
                                                    <path d="M17 2.45597C17.7415 2.59747 18.1811 2.75299 18.5609 3.22083C19.0367 3.80673 19.0115 4.43998 18.9612 5.70647C18.7805 10.2595 17.7601 16 12.0002 16C6.24021 16 5.21983 10.2595 5.03907 5.70647C4.98879 4.43998 4.96365 3.80673 5.43937 3.22083C5.91508 2.63494 6.48445 2.53887 7.62318 2.34674C8.74724 2.15709 10.2166 2 12.0002 2C12.7184 2 13.3857 2.02548 14 2.06829" stroke="#ffaa05" stroke-width="1.5" stroke-linecap="round"></path>
                                                    <path d="M19 5L19.9486 5.31621C20.9387 5.64623 21.4337 5.81124 21.7168 6.20408C22 6.59692 22 7.11873 21.9999 8.16234L21.9999 8.23487C21.9999 9.09561 21.9999 9.52598 21.7927 9.87809C21.5855 10.2302 21.2093 10.4392 20.4569 10.8572L17.5 12.5" stroke="#ffaa05" stroke-width="1.5"></path>
                                                    <path d="M4.99994 5L4.05132 5.31621C3.06126 5.64623 2.56623 5.81124 2.2831 6.20408C1.99996 6.59692 1.99997 7.11873 2 8.16234L2 8.23487C2.00003 9.09561 2.00004 9.52598 2.20723 9.87809C2.41441 10.2302 2.79063 10.4392 3.54305 10.8572L6.49994 12.5" stroke="#ffaa05" stroke-width="1.5"></path>
                                                    <path d="M12 17V19" stroke="#ffaa05" stroke-width="1.5" stroke-linecap="round"></path>
                                                    <path d="M15.5 22H8.5L8.83922 20.3039C8.93271 19.8365 9.34312 19.5 9.8198 19.5H14.1802C14.6569 19.5 15.0673 19.8365 15.1608 20.3039L15.5 22Z" stroke="#ffaa05" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M18 22H6" stroke="#ffaa05" stroke-width="1.5" stroke-linecap="round"></path>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">

                                <div class="card small-widget">
                                    <div class="card-body secondary"><span class="f-light">Gap</span>
                                        <div class="d-flex gap-1 align-items-end">
                                            <h4>{{ formatM(stats?.gap) }}</h4>
                                        </div>
                                        <div class="bg-gradient">
                                            <svg viewBox="0 -0.5 25 25" fill="none" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg">
                                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                                <g id="SVGRepo_iconCarrier">
                                                    <path d="M19.5 19H9.5C7.29086 19 5.5 17.2091 5.5 15V5" stroke="#F42F65" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M15.942 13.25C15.5278 13.25 15.192 13.5858 15.192 14C15.192 14.4142 15.5278 14.75 15.942 14.75V13.25ZM19.5 14.75C19.9142 14.75 20.25 14.4142 20.25 14C20.25 13.5858 19.9142 13.25 19.5 13.25V14.75ZM18.75 14C18.75 14.4142 19.0858 14.75 19.5 14.75C19.9142 14.75 20.25 14.4142 20.25 14H18.75ZM20.25 10.908C20.25 10.4938 19.9142 10.158 19.5 10.158C19.0858 10.158 18.75 10.4938 18.75 10.908H20.25ZM18.9989 14.558C19.3071 14.8348 19.7813 14.8093 20.058 14.5011C20.3348 14.1929 20.3093 13.7187 20.0011 13.442L18.9989 14.558ZM15.039 9.994L15.5401 9.43598C15.5328 9.4294 15.5253 9.42298 15.5178 9.4167L15.039 9.994ZM13.6 9.942L13.1641 9.33157L13.1546 9.33856L13.6 9.942ZM12.638 10.652L13.0744 11.2621L13.0834 11.2554L12.638 10.652ZM11.1 10.494L10.5161 10.9647C10.5265 10.9777 10.5374 10.9903 10.5488 11.0026L11.1 10.494ZM10.983 10.364L11.5124 9.83272C11.5083 9.82871 11.5043 9.82474 11.5002 9.82081L10.983 10.364ZM9.01715 7.45681C8.71716 7.1712 8.24243 7.18285 7.95681 7.48285C7.6712 7.78284 7.68285 8.25757 7.98285 8.54319L9.01715 7.45681ZM15.942 14.75H19.5V13.25H15.942V14.75ZM20.25 14V10.908H18.75V14H20.25ZM20.0011 13.442L15.5401 9.43598L14.5379 10.552L18.9989 14.558L20.0011 13.442ZM15.5178 9.4167C14.8435 8.85747 13.8771 8.82255 13.1641 9.33164L14.0359 10.5524C14.1947 10.4389 14.41 10.4467 14.5602 10.5713L15.5178 9.4167ZM13.1546 9.33856L12.1926 10.0486L13.0834 11.2554L14.0454 10.5454L13.1546 9.33856ZM12.2017 10.042C12.0302 10.1646 11.7942 10.1404 11.6512 9.98545L10.5488 11.0026C11.2047 11.7136 12.2875 11.8248 13.0743 11.262L12.2017 10.042ZM11.6839 10.0233C11.6302 9.95672 11.573 9.89309 11.5124 9.83272L10.4536 10.8953C10.4757 10.9173 10.4965 10.9404 10.5161 10.9647L11.6839 10.0233ZM11.5002 9.82081L9.01715 7.45681L7.98285 8.54319L10.4658 10.9072L11.5002 9.82081Z" fill="#F42F65"></path>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">

                                <div class="card small-widget">
                                    <div class="card-body success">
                                        <div style="display: flex; flex-direction: row; justify-content: space-between; padding-right: 34px;">
                                            <span class="f-light">Forecast</span>
                                            <div class="d-flex flex-row align-items-center justify-content-center" style="gap: 2px;">
                                                <svg viewBox="0 -0.5 25 25" width="18px" height="18px" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                                    <g id="SVGRepo_iconCarrier">
                                                        <path d="M15.5 7.75C15.0858 7.75 14.75 8.08579 14.75 8.5C14.75 8.91421 15.0858 9.25 15.5 9.25V7.75ZM19.5 9.25C19.9142 9.25 20.25 8.91421 20.25 8.5C20.25 8.08579 19.9142 7.75 19.5 7.75V9.25ZM20.25 8.5C20.25 8.08579 19.9142 7.75 19.5 7.75C19.0858 7.75 18.75 8.08579 18.75 8.5H20.25ZM18.75 12.5C18.75 12.9142 19.0858 13.25 19.5 13.25C19.9142 13.25 20.25 12.9142 20.25 12.5H18.75ZM20.0303 9.03033C20.3232 8.73744 20.3232 8.26256 20.0303 7.96967C19.7374 7.67678 19.2626 7.67678 18.9697 7.96967L20.0303 9.03033ZM12.5 15.5L11.9697 16.0303C12.2626 16.3232 12.7374 16.3232 13.0303 16.0303L12.5 15.5ZM9.5 12.5L10.0303 11.9697C9.73744 11.6768 9.26256 11.6768 8.96967 11.9697L9.5 12.5ZM4.96967 15.9697C4.67678 16.2626 4.67678 16.7374 4.96967 17.0303C5.26256 17.3232 5.73744 17.3232 6.03033 17.0303L4.96967 15.9697ZM15.5 9.25H19.5V7.75H15.5V9.25ZM18.75 8.5V12.5H20.25V8.5H18.75ZM18.9697 7.96967L11.9697 14.9697L13.0303 16.0303L20.0303 9.03033L18.9697 7.96967ZM13.0303 14.9697L10.0303 11.9697L8.96967 13.0303L11.9697 16.0303L13.0303 14.9697ZM8.96967 11.9697L4.96967 15.9697L6.03033 17.0303L10.0303 13.0303L8.96967 11.9697Z" fill="#039D71"></path>
                                                    </g>
                                                </svg>
                                                <small style="color:#039D71">{{ stats.forecast_pct }}%</small>
                                            </div>
                                        </div>
                                        <div class="d-flex gap-1 align-items-end">
                                            <h4>{{ formatM(stats?.forecast) }}</h4>
                                        </div>
                                        <div class="bg-gradient">
                                            <svg viewBox="0 -0.5 25 25" width="24px" height="24px" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                                <g id="SVGRepo_iconCarrier">
                                                    <path d="M19.5 19H9.5C7.29086 19 5.5 17.2091 5.5 15V5" stroke="#039D71" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M15.619 7.25C15.2048 7.25 14.869 7.58579 14.869 8C14.869 8.41421 15.2048 8.75 15.619 8.75V7.25ZM19.5 8.75C19.9142 8.75 20.25 8.41421 20.25 8C20.25 7.58579 19.9142 7.25 19.5 7.25V8.75ZM20.25 8C20.25 7.58579 19.9142 7.25 19.5 7.25C19.0858 7.25 18.75 7.58579 18.75 8H20.25ZM18.75 11.607C18.75 12.0212 19.0858 12.357 19.5 12.357C19.9142 12.357 20.25 12.0212 20.25 11.607H18.75ZM20.0765 8.47973C20.3414 8.16133 20.2981 7.68844 19.9797 7.42349C19.6613 7.15855 19.1884 7.20188 18.9235 7.52027L20.0765 8.47973ZM15.5 12.807L16.0038 13.3626C16.0298 13.339 16.054 13.3137 16.0765 13.2867L15.5 12.807ZM13.931 12.868L13.4663 13.4567L13.4718 13.461L13.931 12.868ZM12.882 12.04L13.3467 11.4513L13.3429 11.4483L12.882 12.04ZM11.2 12.223L10.6226 11.7443C10.6152 11.7532 10.608 11.7623 10.601 11.7716L11.2 12.223ZM11.072 12.375L11.6074 12.9002C11.6112 12.8963 11.615 12.8923 11.6187 12.8884L11.072 12.375ZM7.83052 14.6088C7.54048 14.9046 7.54508 15.3794 7.8408 15.6694C8.13652 15.9595 8.61138 15.9549 8.90141 15.6592L7.83052 14.6088ZM15.619 8.75H19.5V7.25H15.619V8.75ZM18.75 8V11.607H20.25V8H18.75ZM18.9235 7.52027L14.9235 12.3273L16.0765 13.2867L20.0765 8.47973L18.9235 7.52027ZM14.9962 12.2514C14.8266 12.4052 14.5711 12.4151 14.3901 12.275L13.4718 13.461C14.228 14.0465 15.2953 14.005 16.0038 13.3626L14.9962 12.2514ZM14.3956 12.2793L13.3466 11.4513L12.4173 12.6287L13.4663 13.4567L14.3956 12.2793ZM13.3429 11.4483C12.5051 10.7957 11.3004 10.9268 10.6226 11.7443L11.7773 12.7017C11.9377 12.5082 12.2228 12.4772 12.4211 12.6317L13.3429 11.4483ZM10.601 11.7716C10.5774 11.8029 10.5521 11.833 10.5252 11.8616L11.6187 12.8884C11.6826 12.8203 11.7427 12.7489 11.7989 12.6744L10.601 11.7716ZM10.5365 11.8498L7.83052 14.6088L8.90141 15.6592L11.6074 12.9002L10.5365 11.8498Z" fill="#039D71"></path>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row mb-2 ">
                            <div class="col-md-3">
                                <b-form-group label="Team" label-for="team">
                                    <b-form-select
                                        id="team"
                                        v-model="selectedTeam"
                                        :options="teamOptions"
                                    >
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>
                                                Select Team
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-md-3">
                                <b-form-group label="Year" label-for="year">
                                    <b-form-select
                                        id="year"
                                        v-model="selectedYear"
                                        :options="yearOptions"
                                    >
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>
                                                Select Year
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </div>

                            <!-- Center vertically -->
                            <div
                                class="col-md-3 d-flex align-items-center"
                            >
                                <div
                                    v-if="selectedTeam || selectedYear"
                                    @click="clearFilter()"
                                    style="
                                        display: flex;
                                        gap: 12px;
                                        align-items: center;
                                        color: white;
                                        background-color: #dc3545;
                                        padding: 8px 14px;
                                        border-radius: 5px;
                                        cursor: pointer;
                                        height: fit-content;
                                    "
                                >
                                    <feather type="x"></feather>
                                    <span>Clear All</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div style="overflow-x: auto; width: 100%;">
                                     <TargetTable :table="targets" @save="handleSave" />
                                </div>
                            </div>
                            

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
    <!-- Target Create Modal -->
    <b-modal id="target-create-modal" size="md" ref="modal" title="Add Target" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">

            <b-form-group label="Product" label-for="name-input" invalid-feedback="Product is required" :state="nameState">
                <b-form-input id="name-input" v-model="target.product" :state="nameState" required></b-form-input>
            </b-form-group>

            <b-form-group label="Team Name" label-for="team-name" invalid-feedback="Team is required" :state="nameState">
                <b-form-select id="team-name" v-model="target.team" :options="teamOptions" :state="nameState">
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Team
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Month" label-for="month" invalid-feedback="Month is required" :state="nameState">
                        <b-form-select id="month" v-model="target.month" :options="monthOptions" :state="nameState">
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Month
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Year" label-for="year" invalid-feedback="Year is required" :state="nameState">
                        <b-form-select id="year" v-model="target.year" :options="yearOptions" :state="nameState">
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Year
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <b-form-group label="Target Value" label-for="target-value-input" invalid-feedback="Target value is required" :state="nameState">
                <b-form-input id="target-value-input" v-model.number="target.target_value" type="number" min="0" placeholder="Enter Target Value" :state="nameState"></b-form-input>
            </b-form-group>

        </form>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import TargetTable from './target-table.vue';
export default {
    components:{
        TargetTable
    },
    data() {
        return {
            nameState: null,
            target: {
                product: null,
                team: null,
                month: null,
                year: null,
                target_value: 0,

            },
            teamOptions: [{
                    id: 1,
                    value: 'Team A',
                    text: 'Team A'
                },
                {
                    id: 2,
                    value: 'Team B',
                    text: 'Team B'
                },
                {
                    id: 3,
                    value: 'Team C',
                    text: 'Team C',
                }
            ],
            monthOptions: [{
                    id: 1,
                    value: 1,
                    text: 'January'
                },
                {
                    id: 2,
                    value: 2,
                    text: 'February'
                },
                {
                    id: 3,
                    value: 3,
                    text: 'March'
                },
                {
                    id: 4,
                    value: 4,
                    text: 'April'
                },
                {
                    id: 5,
                    value: 5,
                    text: 'May'
                },
                {
                    id: 6,
                    value: 6,
                    text: 'June'
                },
                {
                    id: 7,
                    value: 7,
                    text: 'July'
                },
                {
                    id: 8,
                    value: 8,
                    text: 'August'
                },
                {
                    id: 9,
                    value: 9,
                    text: 'September'
                },
                {
                    id: 10,
                    value: 10,
                    text: 'October'
                },
                {
                    id: 11,
                    value: 11,
                    text: 'November'
                },
                {
                    id: 12,
                    value: 12,
                    text: 'December'
                }
            ],
            yearOptions: [],
            filterShow : false,
            selectedTeam: null,
            selectedYear : null,
            initialLoad: true,
         
        };
    },

    computed: {
        ...mapState({
            stats: state => state.target.stats,
            targets: state => state.target.targets_list,
        }),

    },
    watch: {
        selectedTeam(newVal, oldVal) {
            if (!this.initialLoad) {
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedYear(newVal, oldVal) {
            if (!this.initialLoad) {
                this.updateRouteQuery();
                this.fetchData();
            }
        },
    },

    mounted() {
        this.yearOptions = this.getYearOptions()
        this.$store.dispatch('target/fetchTargetStats');
        // this.$store.dispatch('target/fetchTargetTable');

        const query = this.$route.query;
        if (query.team) {
            this.selectedTeam = query.team;
        }
        if (query.year) {
            this.selectedTeam = query.year;
        }
        if (this.selectedTeam || this.selectedYear) {
            this.filterShow = true;
        }

        this.updateRouteQuery();
        this.fetchInitialUpdate();

    },

    methods: {
        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },
        clearFilter(){
            this.selectedTeam = null;
            this.selectedYear = null;
        },
        updateRouteQuery() {
            const query = {};

            if (this.selectedTeam) {
                query.team = this.selectedTeam;
            }
            if (this.selectedYear ) {
                query.year = this.selectedYear;
            }
            
            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({
                    path: this.$route.path,
                    query
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        },
        fetchInitialUpdate() {
            this.$store.dispatch("target/fetchTargetTable", {
               year: this.selectedYear,
               team: this.selectedTeam
            }).then(() => {
                // this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        fetchData() {
            if (!this.initialLoad) {
                this.$store.dispatch("target/fetchTargetTable", {
                      year: this.selectedYear,
                      team: this.selectedTeam

                }).then(() => {
                    // this.totalRows = this.count;
                });
            }
        },
        resetModal() {
            this.target = {
                product: null,
                team: null,
                month: null,
                year: null,
                target_value: 0,

            };
            this.nameState = null
        },

        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },
        formatM(value) {
            if (value === null || value === undefined) return 'N/A';
            if (value === 0) return '৳ 0';
            if (value >= 1_000_000) return '৳ ' + (value / 1_000_000).toFixed(1) + 'M';
            if (value >= 1_000)    return '৳ ' + (value / 1_000).toFixed(1) + 'K';
            return '৳ ' + value.toLocaleString();
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        getYearOptions(previousYears = 5, nextYears = 10) {
            const currentYear = new Date().getFullYear()

            return Array.from({
                    length: previousYears + nextYears + 1
                },
                (_, index) => {
                    const year = currentYear - previousYears + index

                    return {
                        value: year,
                        text: year.toString()
                    }
                }
            )
        },
        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },
        handleSubmit() {
            if (!this.checkFormValidity()) {
                return
            }
            this.$store.dispatch("target/addTarget", {
                target: this.target,
                year: this.selectedYear,
                team: this.selectedTeam
            }).then(response => {
                if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                    this.resetModal()
                    this.$nextTick(() => {
                        this.$bvModal.hide('target-create-modal')
                    })

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

        },
        handleSave(changedData) {
        this.$store.dispatch("target/targetBulkUpdate", {
            changedData: changedData,
            year: this.selectedYear,
            team: this.selectedTeam

        },
                    
        ).then(response => {
            if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
            } else {
                Swal.fire({
                    title: "Error!",
                    text: response.response,
                    icon: "error"
                });
            }
        })
            
        }
    },
};
</script>

<style scoped>
.small-widget {
    overflow: hidden;
}

.warning .bg-gradient {
    background-image: linear-gradient(144.16deg, rgba(255, 170, 5, .1) 19.06%, rgba(255, 170, 5, 0) 79.03%) !important;
}

.success .bg-gradient {
    background-image: linear-gradient(144.16deg, rgba(84, 186, 74, .1) 19.06%, rgba(84, 186, 74, 0) 79.03%) !important;
}

.secondary .bg-gradient {
    background-image: linear-gradient(144.16deg, rgba(255, 51, 100, .1) 19.06%, rgba(255, 51, 100, 0) 79.03%) !important;
}

.primary .bg-gradient {
    background-image: linear-gradient(144.16deg,
            rgba(115, 102, 255, 0.1) 19.06%,
            rgba(115, 102, 255, 0) 79.03%) !important;
}

.secondary .svg-fill {
    fill: #F73A6A;
}

.success .svg-fill {
    fill: #54ba4a;
}

.warning .svg-fill {
    fill: #ffaa05;
}

.primary .svg-fill {
    fill: #7366ff;
}

.small-widget .bg-profile {
    width: 125px;
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    left: -12px;
    top: 50%;
    position: absolute;
    transform: translateY(-50%);
}

.small-widget .profile-info {
    display: flex;
    flex-direction: column;
    top: 50%;
    position: absolute;
    transform: translateY(-50%);
}

.small-widget .bg-gradient {
    width: 66px;
    height: 67px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    right: -12px;
    top: 50%;
    position: absolute;
    transform: translateY(-50%);
}

.small-widget:hover {
    transform: translateY(-3px);
}
</style>
